import React from "react";
import { HashRouter, Routes, Route } from "react-router-dom";
import StudentsList from "./components/students/StudentsList";
import StudentPage from "./components/students/StudentPage";
import DatePage from "./components/notes/DatePage";
import ArchivePage from "./components/archive/ArchivePage";
import ScrollToTop from "./components/layout/ScrollToTop";

function App() {
  return (
    <HashRouter>
      <ScrollToTop>
        <Routes>
          <Route path="/" element={<StudentsList />} />
          <Route path="/student/:id" element={<StudentPage />} />
          <Route path="/student/:id/date/:date" element={<DatePage />} />
          <Route path="/archive" element={<ArchivePage />} />
        </Routes>
      </ScrollToTop>
    </HashRouter>
  );
}

export default App;
